
import './StreamingMarkdown.css';
import { PartialMarkdownRenderer } from './PartialMarkdownRenderer';

interface StreamingMarkdownProps {
  content: string;
  isStreaming?: boolean;
  isFromAI?: boolean;
}

/**
 * Оптимизированный компонент для отображения потокового маркдауна.
 * Использует дебаунсинг и мемоизацию для улучшения производительности.
 */
export function StreamingMarkdown({ 
  content, 
  isStreaming = false,
  isFromAI = false
}: StreamingMarkdownProps) {

  // Для пустого контента показываем placeholder
  if (!content || content.trim() === '') {
    return (
      <div className="text-gray-400 dark:text-gray-500 italic">
        {isStreaming ? 'Печатает...' : 'Пустое сообщение'}
      </div>
    );
  }

  // Для потокового режима используем специальный рендерер
  if (isStreaming) {
    return (
      <div className="streaming-markdown">
        <PartialMarkdownRenderer 
          content={content}
          isFromAI={isFromAI}
        />
        
        {/* Курсор стриминга */}
        <span className="inline-block w-2 h-4 bg-current opacity-70 animate-pulse ml-1 align-text-bottom"></span>
      </div>
    );
  }

  // Для финализированных сообщений тоже используем PartialMarkdownRenderer
  // это гарантирует консистентность форматирования
  return (
    <div className="streaming-markdown">
      <PartialMarkdownRenderer 
        content={content}
        isFromAI={isFromAI}
      />
      
    </div>
  );
}